var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedMgmtNonAc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#F3E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0227 23.6494C18.1495 24.0907 17.1673 24.2698 16.1945 24.1651C15.2218 24.0604 14.3001 23.6764 13.5408 23.0595C12.7814 22.4425 12.2169 21.619 11.9153 20.6883C11.6137 19.7576 11.5879 18.7595 11.8411 17.8144L16.3511 19.0227C15.9098 18.1495 15.7307 17.1673 15.8354 16.1945C15.9401 15.2218 16.324 14.3001 16.941 13.5408C17.5579 12.7814 18.3815 12.2169 19.3122 11.9153C20.2429 11.6137 21.241 11.5879 22.1861 11.8411L20.9777 16.3511C21.8509 15.9098 22.8332 15.7307 23.806 15.8354C24.7787 15.9401 25.7004 16.324 26.4597 16.941C27.219 17.5579 27.7836 18.3815 28.0852 19.3122C28.3868 20.2429 28.4126 21.241 28.1594 22.1861L23.6494 20.9777C24.0907 21.8509 24.2698 22.8332 24.1651 23.806C24.0604 24.7787 23.6764 25.7004 23.0595 26.4597C22.4425 27.219 21.619 27.7836 20.6883 28.0852C19.7576 28.3868 18.7595 28.4126 17.8144 28.1594L19.0227 23.6494Z",
    stroke: "#7F56D9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V20.0083",
    stroke: "#7F56D9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedMgmtNonAc);
export default __webpack_public_path__ + "static/media/bedMgmtNonAC.3da1664d2a8437ecb970057c728e6ec9.svg";
export { ForwardRef as ReactComponent };